module.exports = {"AutoFillDateCheck":{"target":"deutscheBahn dev"},"Autosave":{"target":"prod dev training deutscheBahn"},"MultipleDomains":{"target":"dev china"},"SurveyAnswerHistory":{"target":"dev training deutscheBahn"}}


//////////////////
// WEBPACK FOOTER
// ./features.json
// module id = 288
// module chunks = 1 2